<style>
	.bill-filter-mask{
		position: fixed;
		width: 100%;
		background-color: rgba(0,0,0,.3);
		z-index: 5;
		top: 0;
		bottom: 0;
		left: 0%
	}
	.bill-filter-wrapper{
		background: #ececec;
		position: absolute;
		height: 100%;
		width: 100%;
		left: 0%;
		overflow:hidden;
	}
	.bill-filter-wrapper .bill-filter-listdiv{
		margin-bottom: 1em;
		padding: .4em 1em;
		background-color: #fff;
		clear: both;
		border-bottom: solid 1px #ddd;
	}
	.bill-filter-wrapper .bill-filter-first{
		float: left;
		width: 90%;
	}
	.bill-filter-wrapper .bill-filter-first a{
		border:solid 1px #eee;
		padding: .4em 1.2em;
		border-radius:5px;
	}
	.bill-filter-wrapper .bill-filter-listdiv .bill-filter-cancel{
		float: left;
		background-color: #eee;
		color: #7c7c7c;
	}
	.bill-filter-wrapper .bill-filter-listdiv .bill-filter-confirm{
		float: right;
		background-color: #26a1a4;
		color: #fff;

	}
	.bill-filter-wrapper .bill-filter-listdiv .bill-filter-date{
		box-sizing: border-box;
		border: solid 1px #eee;
		/*display: inline-block;*/
		float: left;
		width: 36%;
		border-radius: 3px;
		padding: 5px;
		background-color: #ffffff !important;
		outline: none;
	}
	.bill-filter-wrapper .bill-filter-listdiv .bill-filter-label{
		box-sizing: border-box;
		display: inline-block;
		width: 32%;
		border-radius:3px;
		margin-top: .4em;
		position: relative;
	}
	.bill-filter-wrapper .bill-filter-listdiv .bill-filter-label span{
		box-sizing: border-box;
		display: block;
		width: 100%;
		height: 100%;
		border:solid 2px #dbdbdb;
		padding: .4em .6em;
		border-radius: 3px;
		color: #dbdbdb;
		text-align:center;
	}
	.bill-filter-wrapper .bill-filter-listdiv .bill-filter-label input[type="checkbox"]{
		position: absolute;
		bottom: -2px;
		right: -2px;
	}
	.bill-filter-wrapper .bill-filter-listdiv .bill-filter-label input[type="checkbox"]:after{
		content: url('../assets/allorderbill/uncheck.png');
		position: absolute;
		top: -2px;
		left: -2px;
	}
	.bill-filter-wrapper .bill-filter-listdiv .bill-filter-label input[type="checkbox"]:checked:after{
		content: url('../assets/allorderbill/check.png');
		position: absolute;
		top: -2px;
		left: -2px;
	}
	.bill-filter-wrapper .bill-filter-listdiv .bill-filter-label input[type="checkbox"]:checked + span{
		border:solid 2px #26a1a4;
		color: #656565;
	}
	.bill-filter-wrapper .bill-filter-listdiv .bill-filter-ullist li{
		padding: .5em 0;
	}
	.bill-filter-wrapper .bill-filter-listdiv .bill-filter-ullist li:first-child{
		border-bottom: solid 1px #eee;
	}
	.bill-filter-wrapper .bill-filter-listdiv .bill-filter-ullist label{
		display: block;
	}
	.bill-filter-wrapper .bill-filter-listdiv .bill-filter-ullist label input[type="radio"]{
		float: right;
		position: relative;
	}
	.bill-filter-wrapper .bill-filter-listdiv .bill-filter-ullist label input[type="radio"]:after{
		content: '';
		position: absolute;
		width: 20px;
		height: 20px;
		background-color: #fff;
		top: -4px;
		left: -2px;
	}
	.bill-filter-wrapper .bill-filter-listdiv .bill-filter-ullist label input[type="radio"]:checked:after{
		content: url('../assets/allorderbill/radio-check.png');
		position: absolute;
		top: -4px;
		left: -2px;
	}
	.bill-filter-date-listdiv {
		float: left;
		width: 100%
	}
	.bill-filter-date-listdiv  label{
		float: left;
		margin: 5px
	}
	.bill-filter-date-listdiv span{
		color: #eee;
		float:left;
		margin: 0 2px
	}
	.summary-filter-ul li input[type="date"].bill-filter-date{
		width: 75%;
		margin-right:30px;
		text-align:right;
	}
	.summary-filter-cancel-btn{
		display: block;
	    background-color: #eee;
	    color: #848484;
	    text-align: center;
	    margin: 1em;
	    padding: .5em 1em;
	    border-radius: 5px;
	}
	.bill-filter-cancel{
		position: absolute;
		color: rgba(255,255,255,.8);
		z-index: 100;
		height: 25px;
		top: 7px;
		left: 7px;
	}
	.bill_filter_div {
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 72%;
		overflow: hidden;
		float: right;
		margin-right: 1.5em;
		text-align: right;
	}
	.bill_filter_div > span {
		float:none !important;
		margin-right: 0 !important;
	}
	.bill-filter-state {
		display: inline;
		float: right;
		margin-right: 22px;
		width: 70%;
		text-align: right;
	}
	.bill-filter-state-label {
		display: inline;
	}
</style>
<template>
<span>
	<transition name="slide">
		<div v-if="show" class="bill-filter-mask">
			<div class="bill-filter-wrapper">
				<a class="bill-filter-cancel" @click="cancel">取消</a>
				<navbar title="餐企订单筛选"></navbar>
				<div class="summary-filter-shell">
					<ul class="summary-filter-ul">
						<li style="background: none">开始日期：&nbsp;
							<input class="bill-filter-date" type="date" v-model="start_date" />
						</li>
						<li style="background: none">结束日期：&nbsp;
							<input class="bill-filter-date" type="date" v-model="end_date" />
						</li>
						<li @click="selectBillStatus(billState, billStateFont)">
							<div class="bill-filter-state-label">单据状态：</div>
							<div class="bill-filter-state">{{billStateFont}}</div>
						</li>
						<li @click="selectDateType">排序方式：&nbsp; <span>{{dateTypeFont}}</span></li>
					</ul>
					<a class="summary-filter-btn" @click="confirm">确定</a>
				</div>
			</div>
		</div>
	</transition>
	<tips v-show="tips" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatus"></tips>
	<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
	<bill-status-select ref="billStatuselectShow" v-on:confirm="getBillStatus" :billStatusFlag="billState" :billStateFont="billStateFont" :statusList="orderBillStatusList" title="餐企订单-选择单据状态"></bill-status-select>
	<date-type-select ref="dateTypeShow" v-on:selectDateType="getDateType" :dateTypeFlag="dateTypeFlag" title="餐企订单-选择排序方式"></date-type-select>
</span>
</template>
<script>
import NavBar from '../components/NavBar'
import Tips from '../components/Tips'
import TipsAuto from '../components/TipsAuto'
import BillStatusSelect from '../components/BillStatusSelectM'
import DateTypeSelect from '../components/DateTypeSelect'
import { GlobalStore } from '../store/globalStore'
export default {
	props: {
		filterBillState: String,
		filterSort: String,
		filterStarDate: String,
		filterEndDate: String,
		filterBillFont: String
	},
	data () {
		return {
			dateTypeFlag: '',
			dateTypeFont: '',
			tips: false,
			tipsauto: false,
			msg: [],
			btnNum: 1,
			tipsFont: '',
			show: false,
			billState: '',
			// billState: '',
			billStateFont: '',
			sort: '',
			start_date: '',
			end_date: '',
			sec: 1500,
			store: GlobalStore,
			billFilterData: {},
			orderBillStatusList: [{
				stateValue: '10',
				stateFont: '未处理',
				checked: false
			}, {
				stateValue: '11',
				stateFont: '待发货',
				checked: false
			}, {
				stateValue: '12',
				stateFont: '已发货',
				checked: false
			}, {
				stateValue: '13',
				stateFont: '已收货 待确认',
				checked: false
			}, {
				stateValue: '14,15,16,17',
				stateFont: '已收货 已确认',
				checked: false
			// }, {
			// 	stateValue: '15',
			// 	stateFont: '确认无差异',
			// 	checked: false
			// }, {
			// 	stateValue: '16',
			// 	stateFont: '同意差异',
			// 	checked: false
			// }, {
			// 	stateValue: '17',
			// 	stateFont: '拒绝差异',
			// 	checked: false
			}]
		}
	},
	created () {
		this.billState = this.filterBillState
		this.billStateFont = this.filterBillFont
		this.dateTypeFlag = this.filterSort
		// window.console.log(this.filterSort)
		// window.console.log(this.billState)
		// 设置默认时间 shang 2017/10/19
		this.start_date = this.filterStarDate
		this.end_date = this.filterEndDate
		this.billFilterData = this.store.billFilterData
	},
	components: {
		'navbar': NavBar,
		'tips': Tips,
		'tips-auto': TipsAuto,
		'bill-status-select': BillStatusSelect,
		'date-type-select': DateTypeSelect
	},
	methods: {
		move (obj) {
			this.show = !this.show
			this.billState = obj.order_state
			this.billStateFont = obj.order_state_font
			this.dateTypeFont = obj.sortFont
			this.sort = obj.sort
		},
		getBillStatus (msg) {
			this.billState = msg[0].join(',')
			this.billStateFont = msg[1].join(',')
			// window.console.log(this.billStateFont)
		},
		getDateType (msg) {
			this.dateTypeFlag = msg
			this.sort = this.dateTypeFlag
			// window.console.log(msg)
			switch (msg) {
			case '0':
				this.dateTypeFont = '订货日期'
				break
			case '1':
				this.dateTypeFont = '到货日期'
				break
			}
		},
		selectBillStatus () {
			var flag = this.billState
			var font = this.billStateFont
			this.$refs.billStatuselectShow.open(flag, font)
		},
		selectDateType () {
			this.$refs.dateTypeShow.open()
		},
		tipStatus (msg) {
			this.tips = msg[0]
		},
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		belong (val) {
			if (this.billState.indexOf(val) !== -1) {
				return true
			} else {
				return false
			}
		},
		sortBy (val) {
			if (this.filterSort === val) {
				return true
			} else {
				return false
			}
		},
		selectState (val) {
			var index = this.billState.indexOf(val)
			if (index === -1) {
				this.billState.push(val)
				// window.console.log(this.billState)
				return false
			} else {
				this.billState.splice(index, 1)
				// window.console.log(this.billState)
				return false
			}
		},
		selectSort (val) {
			if (this.sort === val) {
				return false
			} else {
				this.sort = val
			}
		},
		confirm () {
			if (this.end_date < this.start_date) {
				this.autoTips('结束日期不能小于开始日期')
				return false
			}
			if (this.billState.length === 0) {
				this.autoTips('请至少选择一种单据状态')
				return false
			}
			this.show = false
			// var str = this.sort + '|' + this.billState + '|' + this.start_date + '|' + this.end_date
			// window.console.log(str)
			// 查询条件全局保存 shang 2017/10/19
			this.billFilterData.filterFlag = true
			this.billFilterData.filterStartDate = this.start_date
			this.billFilterData.filterEndDate = this.end_date
			this.billFilterData.filterBillState = this.billState
			this.billFilterData.filterBillStateFont = this.billStateFont
			this.billFilterData.filterBillSort = this.sort
			this.billFilterData.filterBillSortFont = this.dateTypeFont
			console.log(this.store)
			var msg = {
				bill_state: this.billState,
				bill_state_font: this.billStateFont,
				start_date: this.start_date,
				end_date: this.end_date,
				sort: this.sort,
				sortFont: this.dateTypeFont
			}
			this.$emit('confirm', msg)
		},
		cancel () {
			this.show = false
		}
	}
}
</script>



// WEBPACK FOOTER //
// BillFilter.vue?e5c9a4c8